module.exports = __webpack_public_path__ + "static/media/move.b83b5b34.svg";